const calculateIndexValue = (value, max) =>
  100 * ((max - Math.min(Math.max(0, value), max)) / max);

export default calculateIndexValue;



// WEBPACK FOOTER //
// ./src/utils/calculate-index-value.js